module.exports = __webpack_public_path__ + "img/t5-img1.64682534.png";